export default __webpack_public_path__ + "media/images/select2x2-a631b4b39af4d4461fa4297e7606dff0.png";